module.exports = __webpack_public_path__ + "static/media/babyname.0eac57b5.jpg";